// equal low and high estimates (GoGo Fee locked at estimate time) are shown as a single price
export const formatEstimateRange = (low: number | string, high: number | string, separator = ' ~ '): string => {
  if (Number(low) === Number(high)) {
    return `$${low}`;
  }

  return `$${low}${separator}$${high}`;
};
